import React from 'react';
import {useTranslation} from 'react-i18next';
import {s} from '@/app/utils/s';
import Space, {spaceSizes} from '@/app/components/Space';
import AuthTitle from '@/app/features/auth/components/auth_title';
import Button from "@/app/components/button";
import OTPInput from "@/app/components/otp_input";
import styles from "@/app/features/auth/pages/create_pin/styles.module.scss";
import ErrorLine from "@/app/components/error_line/widget";
import useEnterPin from "./slice";

const EnterPinWidget = () => {
  const {t} = useTranslation();
  const {
    setCode,
    continued,
    loading,
    error,
    disabled
  } = useEnterPin();

  return (
    <div className={styles.main} id="main">
      <AuthTitle title={t(s.welcomeBack)} subtitle={t(s.enterYourPin)}/>
      <Space h={spaceSizes.s50}/>
      <OTPInput length={4} onChange={setCode}/>
      <Space h={spaceSizes.s20}/>
      <Button
        isLoading={loading}
        isDisabled={disabled}
        onClick={() => continued()}
      >
        {s.continue}
      </Button>
      <Space h={spaceSizes.s14}/>
      <ErrorLine className={styles.errorLine} error={error}/>
    </div>
  );
};

export default EnterPinWidget;